module.exports = __webpack_public_path__ + "static/media/bike.ba5836bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scss/icons/gift/bike.svg
// module id = 917
// module chunks = 0